import IDraggable from '@/Domain/interfaces/IDraggable';

export default class DocumentsDragHandler implements IDraggable {
    dragging: boolean = false;
    isDragableDisabled: boolean = false;
    readonly dragClass: string = 'draggable';

    onMove(evt) {
        return evt.dragged.classList.contains(this.dragClass)
            && (!evt.related || evt.related.classList.contains(this.dragClass));
    }

    onDragEnd(evt) {
        if (!evt.clone.classList.contains(this.dragClass)) {
            return;
        }
    }
}
